import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-arrow--cart-back",
  "use": "icon-arrow--cart-back-usage",
  "viewBox": "0 0 38 11",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 38 11\" id=\"icon-arrow--cart-back\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M5.665 0 1.063 4.469l-.001-.002L0 5.498v.004l1.062 1.031.001-.001L5.665 11 6.73 9.967 2.878 6.229h35.121V4.771H2.878l3.852-3.74L5.665 0Z\" fill=\"#6611F5\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol